// stores/useLoadingStore.js
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useLoadingStore = defineStore('loading', () => {
  // 当前正在执行的任务列表
  const loadingTasks = ref(new Set())

  // 是否显示 loading（延迟后为 true）
  const showLoading = ref(false)

  // 延迟计时器
  let timer = null

  // 延迟时间（毫秒）
  const DELAY = 300

  /**
   * 开始加载任务
   * @param {string} taskId - 任务唯一标识
   */
  function start(taskId) {
    loadingTasks.value.add(taskId)

    // 清除之前的定时器
    clearTimeout(timer)

    // 延迟后显示 loading
    timer = setTimeout(() => {
      if (loadingTasks.value.size > 0) {
        showLoading.value = true
      }
    }, DELAY)
  }

  /**
   * 结束加载任务
   * @param {string} taskId - 任务唯一标识
   */
  function stop(taskId) {
    loadingTasks.value.delete(taskId)

    // 所有任务都完成了，隐藏 loading
    if (loadingTasks.value.size === 0) {
      clearTimeout(timer)
      showLoading.value = false
    }
  }

  /**
   * 是否有任务正在加载
   */
  // ✅ isLoading 可以改为直接暴露 loadingTasks，但为了语义清晰保留 computed
  const isLoading = computed(() => loadingTasks.value.size > 0)

  // ✅ 新增：清空所有任务（异常情况兜底）
  function clearAll() {
    loadingTasks.value.clear()
    clearTimeout(timer)
    showLoading.value = false
  }

  return {
    // State（直接暴露 ref）
    loadingTasks,
    showLoading,

    // Getters
    isLoading,

    // Actions
    start,
    stop,
    clearAll,
  }
})